import MyService from '../../service';

const MarketingLeadApi = {
  index: async () => {
    try {
      const { data } = await MyService.getRequestData('/marketing-lead');

      return data || [];
    } catch (e) {
      console.error(e);
      return [];
    }
  },
  show: async (id) => {
    try {
      const { data } = await MyService.getRequestData(`/marketing-lead/${id}`);

      return data || null;
    } catch (e) {
      console.error(e);
      return null;
    }
  },
  create: async (param) => {
    try {
      return MyService.postRequestData(`/marketing-lead`, param);
    } catch (e) {
      console.error(e);
      return e;
    }
  },
  edit: async (id, param) => {
    try {
      return MyService.putRequestData(`/marketing-lead/${id}`, param);
    } catch (e) {
      console.error(e);
      return null;
    }
  },

  getLeadFailReason: async () => {
    try {
      const { data } = await MyService.getRequestData('/fail-reason');

      return data || [];
    } catch (e) {
      console.error(e);
      return [];
    }
  },
};

export default MarketingLeadApi;
